export const sourcesDestinationsConstants = {
  GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_REQUEST: "GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_REQUEST",
  GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_SUCCESS: "GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_SUCCESS",
  GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_FAILURE: "GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_FAILURE",

  EDIT_SOURCE_AND_DESTINATION_BY_ID_REQUEST: "EDIT_SOURCE_AND_DESTINATION_BY_ID_REQUEST",
  EDIT_SOURCE_AND_DESTINATION_BY_ID_SUCCESS: "EDIT_SOURCE_AND_DESTINATION_BY_ID_SUCCESS",
  EDIT_SOURCE_AND_DESTINATION_BY_ID_FAILURE: "EDIT_SOURCE_AND_DESTINATION_BY_ID_FAILURE",
  
  DELETE_SOURCE_AND_DESTINATION_BY_ID_REQUEST: "DELETE_SOURCE_AND_DESTINATION_BY_ID_REQUEST",
  DELETE_SOURCE_AND_DESTINATION_BY_ID_SUCCESS: "DELETE_SOURCE_AND_DESTINATION_BY_ID_SUCCESS",
  DELETE_SOURCE_AND_DESTINATION_BY_ID_FAILURE: "DELETE_SOURCE_AND_DESTINATION_BY_ID_FAILURE",
};